import React, { useState, useEffect } from "react"
import './index.css';
import { Table, Dropdown } from "react-bootstrap";
import axios from 'axios';
import { getBetIds, getLoginToken, ORDERSTTAUS_API, MARKET_FETCH_URL, MARKET_TYPE_FETCH_URL, getNewBetIds } from './constants/utils'
const BfQuickResult = (props) => {

  const [betDetails, setBetDetails] = useState([]);
  const [marketDetails, setMarketDetails] = useState([]);
  const [marketType, setMarketType] = useState([]);
  const [filterDate, setFilterDate] = useState('Just For Today');

  function updateMarketData(marketData) {
    //check if marketDetails contains marketData if not then update it
    var alreadyFetched = marketDetails.map(x => x.bfMarketId).includes(marketData.bfMarketId);
    if (!alreadyFetched) {
      //dont need runner metadata delete it.
      marketData.runners.forEach(x => delete x['metadata'])
      marketDetails.push(marketData)
    }
  }

  function getMarketType(marketId) {
    //console.log("vivek123" + JSON.stringify(marketType))
    //return "abc";
    let x = marketType.filter(marketData => marketData.marketId === marketId);
    return x.length > 0 ? x[0].type : ""
  }



  useEffect(() => {
    function updateStatus() {
      var allBetIds = getBetIds();
      var newBetId = getNewBetIds();//current placed bet from browser
      //var savedClearedBets = getClearedBets().map(x => x.betId);
      //Always update status of new betI ids we dont know when it will move to
      //cleared bet. Dont call for already saved cleared bet.
      //let difference = allBetIds.filter(x => !savedClearedBets.includes(x)).concat(newBetId);

      var betIdsToCall = props.type === 'current' ? newBetId : allBetIds;
      if (betIdsToCall && betIdsToCall.length > 0) {
        const postRequestPara = {
          "ssoid": getLoginToken(),
          "orderIds": betIdsToCall,
        }
        axios.post(ORDERSTTAUS_API + props.type, postRequestPara)
          .then((res) => {
            //console.log("Result of LOGIN API ::" + res.data)
            var betDetails = res.data
            if (props.type === 'cleared') {
              //updateClearedBets(betDetails)
              //betDetails = getClearedBets();
            }
            if (betDetails) {
              betDetails.forEach(element => {
                getMarketDetails(element.marketId)
                  .then(result => {
                    updateMarketData(result.data)
                  })
                if (!getMarketType(element.marketId)) {
                  getMarketTypeFromServer(element.marketId)
                    .then(result => {
                      for (const [key, value] of Object.entries(result.data)) {
                        marketType.push({ "marketId": value, "type": key })
                      }
                    })
                }
    
              })
              setBetDetails(betDetails)
            }
          },
            (error) => {
              console.log("Result of API 3 returns Error!!!" + error)
              //NotificationManager.error('Error in Login', '', 5000, () => {
              //console.log('Error message notification clicked');
            });
      }
    }
    updateStatus();
    const intervalId = setInterval(updateStatus, props.refreshTime);
    return () => clearInterval(intervalId);
  }, []);

  function getMarketDetails(marketId) {
    return axios.get(MARKET_FETCH_URL + marketId);
  }

  function getMarketTypeFromServer(marketId) {
    return axios.get(MARKET_TYPE_FETCH_URL + marketId + "/type");
  }


  function getSelectionName(marketId, selectionId) {
    let x = marketDetails
      .flatMap(element => element.runners)
      .filter(element => element.selectionId === Number(selectionId))
      .map(element => element.runnerName)
    return x.length > 0 ? x[0] : selectionId
  }


  function renderBet(bet, index) {
    //console.log("Market Details" + JSON.stringify(marketDetails))
    return (
      <tr key={index}>
        <td>{getSelectionName(bet.marketId, bet.selectionId)}</td>
        <td>{bet.side}</td>
        <td>{getMarketType(bet.marketId)}</td>
        <td>{bet && bet.priceSize ?  bet.priceSize.price : ''}</td>
        <td>{bet && bet.priceSize ? bet.priceSize.size : ''}</td>
      </tr>
    )
  }
  function filterByStausExecutable(bet) {
    return props.filterStatus ? bet.status === 'EXECUTABLE' : true;
  }

  function filterByStausExecutionComplete(bet) {
    return props.filterStatus ? bet.status === 'EXECUTION_COMPLETE' : true;
  }



  function handleSelect(event) {
    setFilterDate(event)
  }

  function filterByMarketId(bet) {
    //get all markets for current win market.
    var winMarket = props.marketId;
    var allMarketids = marketDetails.filter(x => x.bfMarketId === winMarket)
      .map(x => x.marketInfoMarketId)
      .flatMap(x => Object.values(x));

    return bet.marketId === props.marketId || allMarketids.includes(bet.marketId);
  }



  const header = (<tr>
    <th>Selection</th>
    <th>Bet Type</th>
    <th>Market Type</th>
    <th>Price</th>
    <th>Stake</th>
  </tr>);

function renderCompleteBet(bet, index) {
  //console.log("Market Details" + JSON.stringify(marketDetails))
  return (
    <tr key={index}>
      <td>{getSelectionName(bet.marketId, bet.selectionId)}</td>
      <td>{bet.side}</td>
      <td>{getMarketType(bet.marketId)}</td>
      <td>{bet && bet.averagePriceMatched ?  bet.averagePriceMatched : ''}</td>
      <td>{bet && bet.sizeMatched ? bet.sizeMatched : ''}</td>
    </tr>
  )
}


  return (
    <>
      {props.showDateDropDown === 'true' ? (
        <div style={{ display: "flex" }}>
          <label style={{ margin: "5px", fontSize: "14px", padding: "5px", marginBottom: "15px", fontWeight: "700" }}>Period</label>
          <Dropdown size="sm" title='Select Value' onSelect={handleSelect}>
            <Dropdown.Toggle size="sm" style={{ backgroundColor: '#303f9f' }}>
              {filterDate}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item eventKey="Just For Today">Just For Today</Dropdown.Item>
              <Dropdown.Item eventKey="From Yesterday">From Yesterday</Dropdown.Item>
              <Dropdown.Item eventKey="Last 7 Days">Last 7 Days</Dropdown.Item>
              <Dropdown.Item eventKey="Last 30 Days">Last 30 Days</Dropdown.Item>
              <Dropdown.Item eventKey="Last 3 Months">Last 3 Months</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>) : null}
      <div class="quick-result-row">
        <div class="quick-result-column">
          <div style={{textAlign:"center", fontSize:"17px", marginBottom:"3px"}}> Unmatched Bets</div>
          <table class="quick-result-table">
            {header}
            {betDetails ? betDetails.filter(filterByStausExecutable).map(renderBet) : ''}
          </table>
        </div>
        <div class="quick-result-column">
          <div style={{textAlign:"center", fontSize:"17px", marginBottom:"3px"}}> Matched Bets</div>
          <table class="quick-result-table">
            {header}
            {betDetails ? betDetails.filter(filterByStausExecutionComplete).filter(filterByMarketId).map(renderCompleteBet) : ''}
          </table>
        </div>
      </div>
      
    </>
  )
}
export default BfQuickResult
